<template>
  <v-row>
    <v-col class="text-center">
      <p>Firebase</p>
    </v-col>
  </v-row>
</template>
  
  <script>
export default {
  name: "Firebase",
};
</script>
  